import { useState } from "react";
import Layout from "@/components/Layout";
import { StatsPanel } from "@/components/StatsPanel";

export default function StatsPage() {
  const [year, setYear] = useState(new Date().getFullYear());

  return (
    <Layout year={year} setYear={setYear}>
      <div className="mb-8 fade-in">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#CFA66A] mb-2">
          &mdash; {year} Performance
        </p>
        <h1 className="font-head text-4xl sm:text-5xl font-bold text-[#EBE5D9]">
          Statistics
        </h1>
      </div>

      <StatsPanel year={year} />
    </Layout>
  );
}
